// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fwGX3","left":"styles_left__thaTK","desktopActions":"styles_desktopActions__2bQsH","title":"styles_title__jgmMj"};